const HomeNavIcon = ({
  className = 'stroke-green-800'
}: {
  className?: string
}) => (
  <svg
    width='24'
    height='27'
    viewBox='0 0 24 27'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.8425 9.55726L13.8425 4.40244C12.7595 3.47132 11.2425 3.47132 10.1585 4.40244L4.15849 9.55726C3.42749 10.1846 3.00049 11.15 3.00049 12.1728V20.2723C3.00049 22.1025 4.34349 23.5858 6.00049 23.5858H18.0005C19.6575 23.5858 21.0005 22.1025 21.0005 20.2723V12.1728C21.0005 11.15 20.5735 10.1846 19.8425 9.55726Z'
      strokeWidth='2.20905'
    />
    <path
      d='M16.0005 16.1169C13.7905 18.5579 10.2085 18.5579 8.00049 16.1169'
      strokeWidth='2.20905'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default HomeNavIcon
